const key = "AIzaSyB79-846MtBL4Qo5LM5j_e3rzGxL7R8tss";

const api = {
    search: async (query) => {
        const request = await fetch(`
            https://www.googleapis.com/youtube/v3/search?key=${key}&part=snippet&q=${query}`);
        
        const data = await request.json();
        const music = await data.items[0];

        return {
            id: music.id.videoId,
            thumbNail: music.snippet.thumbnails.medium.url,
            title: music.snippet.title,
        };
    }
};

export default api;